export default "__VITE_ASSET__dHN_KuDM__"